import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@capintel/component-lib/typography';

import { ReduxState } from '../../../redux/modules/types';
import { clearTimeout } from '../../../redux/modules/auth';
import { FormattedMessage } from '../../../utils/i18n';
import DefaultModal from './DefaultModal';

type DispatchProps = {
  clearTimeout: () => void;
};

type StateProps = {
  show: boolean;
  timeoutUrl?: string;
};

type Props = DispatchProps & StateProps;

const SessionTimeoutModal = ({ show, timeoutUrl, ...props }: Props) => {
  const redirect = () => {
    if (timeoutUrl) {
      window.location.href = timeoutUrl;
    }

    props.clearTimeout();
  };

  const body = (
    <div>
      <i className="icon icon-lock-closed" />
      <Typography variant="headerMd" as="h1">
        <FormattedMessage id="Auth.SessionTimeout.Title" />
      </Typography>
      <Typography variant="bodyMdRegular" as="p">
        <FormattedMessage id="Auth.SessionTimeout.Description" />
      </Typography>
    </div>
  );

  return <DefaultModal className="session-timeout-modal" show={show} onConfirm={redirect} body={body} />;
};

const mapStateToProps = (state: ReduxState) => ({
  show: !!state.auth.timeout,
  timeoutUrl: state.auth.timeoutUrl,
});

export default connect(mapStateToProps, { clearTimeout })(SessionTimeoutModal);
